<template>
    <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 2.66667V17.3333H25.3333V2.66667H4ZM1.33333 1.34267C1.33333 0.601333 1.94 0 2.656 0H26.6773C27.408 0 28 0.598667 28 1.34267V20H1.33333V1.34267ZM0 21.3333H29.3333V24H0V21.3333Z"
            fill="currentColor"/>
    </svg>
</template>
